import React from 'react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="accueil" className="gradient-bg min-h-screen flex items-center justify-center relative overflow-hidden pt-20">
      {/* Decorative Elements */}
      <div className="deco-circle w-96 h-96 top-10 -right-48 animate-float"></div>
      <div className="deco-circle w-72 h-72 bottom-20 -left-36" style={{ animationDelay: '1s' }}></div>
      <div className="deco-square w-32 h-32 top-1/4 right-1/4"></div>
      <div className="deco-square w-20 h-20 bottom-1/3 left-1/4" style={{ animationDelay: '0.5s' }}></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight animate-fade-in-up">
              Vos tâches,<br/>
              <span className="gradient-text bg-gradient-to-r from-yellow-300 to-orange-300">nos solutions</span>
            </h1>
            <p className="text-xl lg:text-2xl mb-8 text-gray-100 animate-fade-in-up delay-200">
              Services professionnels multitâches pour particuliers et entreprises
            </p>
            <div className="flex flex-wrap gap-4 animate-fade-in-up delay-300">
              <button 
                onClick={() => scrollToSection('services')}
                className="btn-primary text-white px-8 py-4 rounded-full font-semibold text-lg relative"
              >
                Découvrir nos services
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-white text-blue-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all"
              >
                Demander un devis
              </button>
            </div>
          </div>

          <div className="relative animate-slide-in-right delay-400">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all">
                <div className="text-4xl mb-2">🌿</div>
                <h3 className="text-white font-bold text-lg mb-1">Jardinage</h3>
                <p className="text-gray-300 text-sm">Entretien d'espaces verts</p>
              </div>
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all" style={{ marginTop: '2rem' }}>
                <div className="text-4xl mb-2">🔧</div>
                <h3 className="text-white font-bold text-lg mb-1">Bricolage</h3>
                <p className="text-gray-300 text-sm">Réparations diverses</p>
              </div>
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all">
                <div className="text-4xl mb-2">📦</div>
                <h3 className="text-white font-bold text-lg mb-1">Déménagement</h3>
                <p className="text-gray-300 text-sm">Manutention pro</p>
              </div>
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all" style={{ marginTop: '2rem' }}>
                <div className="text-4xl mb-2">✨</div>
                <h3 className="text-white font-bold text-lg mb-1">Nettoyage</h3>
                <p className="text-gray-300 text-sm">Entretien complet</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
